import type {ChronologicalCommentsSort} from '@github-ui/commenting/ChronologicalCommentsSort'

import type {TimelineItem} from './IssueTimeline'

/**
 * Items always arrive oldest first. For newest first we flip the list and swap each load marker's callbacks, so
 * `loadFromTop` still loads next to the section above the marker.
 */
export function orderTimelineItems(items: TimelineItem[], sort: ChronologicalCommentsSort): TimelineItem[] {
  if (sort !== 'newest-first') return items

  return items
    .map(item =>
      item.type === 'load'
        ? {
            ...item,
            loadFromTop: item.loadFromBottom,
            loadFromBottom: item.loadFromTop,
            newestFirst: true,
          }
        : item,
    )
    .reverse()
}
